// Third-party
import React from 'react';

// Components
import { IconButton } from '@/views/components/buttons';

type Props = {
  id: string;
  label: string;
  canCancel: boolean;
  onCancel: (id: string) => void;
};

const InfiniteProgressBar: React.FC<Props> = ({ id, label, canCancel, onCancel }) => (
  <div className="infinite-progress-bar">
    <div className="infinite-progress-bar-label">
      <span>{label}</span>
      {canCancel && <IconButton icon="cross-thin" onClick={() => onCancel(id)} />}
    </div>
    <div className="infinite-progress-bar-loading" />
  </div>
);

export default InfiniteProgressBar;
